import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { EffectsModule } from '@ngrx/effects';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { UtilsModule } from '@innogy/utils-deprecated';

import { KnowledgeBaseEffects } from './+state/knowledge-base.effects';
import { CategoryFilterComponent } from './category-filter/category-filter.component';
import { CategoryNavigationComponent } from './category-navigation/category-navigation.component';
import { SubcategoryFilterComponent } from './subcategory-filter/subcategory-filter.component';

@NgModule({
  imports: [
    UtilsModule,
    CommonModule,
    EffectsModule.forFeature([KnowledgeBaseEffects]),
    AnalyticsDirectivesModule,
    FontAwesomeModule,
    JssModule,
    RouterModule,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    LazyLoadImageModule,
    CategoryFilterComponent,
    SubcategoryFilterComponent,
    CategoryNavigationComponent,
  ],
  exports: [
    FontAwesomeModule,
    JssModule,
    CategoryFilterComponent,
    SubcategoryFilterComponent,
    CategoryNavigationComponent,
    RouterModule,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    LazyLoadImageModule,
  ],
})
export class KnowledgeBaseSharedModule {}
